import { render } from "./CustomerItemView.vue?vue&type=template&id=547eae5e"
import script from "./CustomerItemView.vue?vue&type=script&lang=js"
export * from "./CustomerItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__